import { Component, type ReactNode } from "react";

export class ErrorBoundary extends Component<{children:ReactNode},{error:Error|null}>{
  state={error:null as Error|null};
  static getDerivedStateFromError(error:Error){return {error}}
  render(){
    if(!this.state.error)return this.props.children;
    return <div className="grid min-h-screen place-items-center bg-background p-6 text-center">
      <div className="max-w-md">
        <h1 className="text-2xl font-bold">Something went wrong</h1>
        <p className="mt-3 text-sm leading-6 text-muted-foreground">The app hit an unexpected error. Reloading usually fixes it; an active transfer will need to be restarted.</p>
        <button type="button" className="mt-6 inline-flex h-11 items-center rounded-full bg-primary px-6 text-sm font-semibold text-primary-foreground" onClick={()=>window.location.assign("/")}>Reload Share Anywhere</button>
      </div>
    </div>;
  }
}
